import React from "react";
import Context from "../../Context";
import Blocker from "./Blocker";
import BsModal from "./BsModal";
import DefaultNotFound from "./DefaultNotFound";
import ReportHandler from "../../report";
import ReactToPrint from "react-to-print";
import EssenceFiles from "../Essence/EssenceFiles";
export default class WorkdocPrintButton extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      modalShow: false,
      buildResult: {},
      reports: [],
      printRef: React.createRef(),
      printButtonRef: React.createRef(),
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.objectId !== this.props.objectId) {
      this.load();
    }
  }
  load = async () => {
    if (this.props.objectId) {
      this.setState({ pending: true });

      let reports = await this.context.api.qa("/report/object/list", {
        object: this.props.objectId,
      });

      this.setState({ reports, pending: false });
    }
  };
  onReportRequest = async (reportItem) => {
    this.setState({ pending: true });
    let reportHandler = new ReportHandler(reportItem.id);
    await reportHandler.init();
    let buildResult = {};
    if (reportHandler.uuid) {
      buildResult = await reportHandler.build({
        identifier: this.props.objectId,
      });
    }
    this.setState({ buildResult }, () => this.onAfterReportRequest());
  };
  onAfterReportRequest = () => {
    window.setTimeout(() => {
      this.setState({ pending: false });
      if (this.state.printButtonRef.current) {
        this.state.printButtonRef.current.click();
      }
    }, 1000);
  };
  modalShow = () => {
    this.setState({ modalShow: true });
  };
  modalClose = () => {
    this.setState({ modalShow: false });
  };
  render() {
    const { pending, reports, buildResult } = this.state;
    let btnClasses = this.props.className || "btn btn-white btn-icon";
    let extraClasses = "";
    if (pending) extraClasses = "opacity-50";
    return (
      <>
        <BsModal center show={this.state.modalShow} onClose={this.modalClose}>
          <Blocker on={pending}>
            <h5 className="mb-3">Сформировать документ:</h5>
            {reports.length === 0 && <DefaultNotFound />}
            {reports.map((reportitem) => {
              return (
                <div
                  key={reportitem.id}
                  className="py-3 my-1  btn btn-light d-block text-left"
                  onClick={() => this.onReportRequest(reportitem)}
                >
                  <div>{reportitem.label}</div>
                  {reportitem.description && (
                    <div className="small text-dark-50">
                      {reportitem.description}
                    </div>
                  )}
                </div>
              );
            })}
            {buildResult.html && (
              <div>
                <div style={{ display: "none" }}>
                  <div
                    ref={this.state.printRef}
                    className="to-print"
                    dangerouslySetInnerHTML={{
                      __html: buildResult.html || "",
                    }}
                  ></div>
                </div>
                <ReactToPrint
                  trigger={() => <div ref={this.state.printButtonRef}></div>}
                  content={() => this.state.printRef.current}
                />
              </div>
            )}
            {buildResult.id && !buildResult.html && (
              <div className="mt-5">
                <EssenceFiles
                  listOnly
                  essence="report"
                  id={buildResult.id}
                  key={buildResult.id}
                />
              </div>
            )}
          </Blocker>
        </BsModal>
        {reports.length > 0 && (
          <div
            onClick={this.modalShow}
            className={`${btnClasses} ${extraClasses}`}
            title="Печать"
          >
            {this.props.children}
          </div>
        )}
      </>
    );
  }
}
